import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SwitchComponent } from '@progress/kendo-angular-inputs';

@Component({
    standalone: false,
    selector: 'unity-toggle',
    templateUrl: './unity-toggle.component.html',
    styleUrls: ['./unity-toggle.component.scss'],
})
export class UnityToggleComponent{
    @Input() disabled: boolean;
    @Input() controlName: string;
    @Input() toggledOn: boolean;

    @Output() onToggle: EventEmitter<boolean> = new EventEmitter();

    @ViewChild(SwitchComponent, { static: true }) private kendoSwitch: SwitchComponent;

    /**
     * Set the desired state of this toggle instance.
     */
    public toggleExternally(desiredState: boolean): void {
        this.kendoSwitch.checked = desiredState;
        this.toggledOn = desiredState;
    }
};
